import {Table, TBody, Td, Th, Thead, Tr} from '@/components';
import type {AfriexBusinessTransaction} from '@/types/AfriexBusinessTransaction';
import {capitalizeWords} from '@/utils/dashboard';
import * as formaTdate from '@/utils/date';

import formatMerchantStatementValues from './formatMerchantStatementValues';

const MerchantStatementTable = ({
  transactions,
}: {
  transactions: AfriexBusinessTransaction[];
}) => {
  return (
    <Table>
      <Thead>
        <Tr enableHover={false}>
          <Th className="capitalize ps-2">Date</Th>
          <Th className="capitalize">Description</Th>
          <Th className="capitalize">Status</Th>
          <Th className="capitalize">Credit</Th>
          <Th className="capitalize">Debit</Th>
          <Th className="capitalize">Balance</Th>
        </Tr>
      </Thead>

      <TBody>
        {transactions.map((item, idx) => {
          return <TRow transaction={item} key={idx} />;
        })}
      </TBody>
    </Table>
  );
};

export default MerchantStatementTable;

const TRow = ({transaction}: {transaction: AfriexBusinessTransaction}) => {
  const {description, credit, debit, balance} =
    formatMerchantStatementValues(transaction);
  return (
    <>
      <Tr data-cy="merchant-statement-row">
        <Td className={`pl-2 py-2`} data-cy="merchant-statement-row-date">
          {formaTdate.DDMonYYYY(transaction.createdAt?.toString() || '')}
        </Td>
        <Td className={`py-2`} data-cy="merchant-statement-row-description">
          {capitalizeWords(description?.replace(/_/g, ' '))}
        </Td>
        <Td className={`py-2`} data-cy="merchant-statement-row-status">
          {capitalizeWords(transaction.status?.replace(/_/g, ' ') ?? '')}
        </Td>
        <Td className={`py-2`} data-cy="merchant-statement-row-credit">
          {credit || '-'}
        </Td>
        <Td className={`py-2`} data-cy="merchant-statement-row-debit">
          {debit || '-'}
        </Td>
        <Td className={`py-2`}>{balance}</Td>
      </Tr>
    </>
  );
};
